import http from '@/core/http';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import {
  IZoneAreaPageReq,
  IZoneAreaPageRes,
  IZoneAreaSaveReq,
  IRegionAreaLogGetRes,
  IZoneAreaGetRes,
  IZoneAreaUpdateReq,
} from './types';

// 区域设置列表
export const regionAreaPageApi = (data: IZoneAreaPageReq) => {
  return http.post<IZoneAreaPageRes>({
    url: '/ufg/web/v1/region-area/page',
    data,
    isCancelDuplicateUrlRequests: true,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

// 保存区域设置
export const regionAreaSaveApi = (data: IZoneAreaSaveReq) => {
  return http.post({
    url: '/ufg/web/v1/region-area/save',
    data,
    isCancelDuplicateUrlRequests: true,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

// 编辑区域设置
export const regionAreaUpdateApi = (data: IZoneAreaUpdateReq) => {
  return http.post({
    url: '/ufg/web/v1/region-area/update',
    data,
    isCancelDuplicateUrlRequests: true,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

// 操作日志
export const regionAreaLogApi = (regionId: string) => {
  return http.get<IRegionAreaLogGetRes>({
    url: `/ufg/web/v1/region-area-log/get/${regionId}`,
    isCancelDuplicateUrlRequests: true,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

// 获取区域管理信息详情
export const regionAreaDetailApi = (regionId: string) => {
  return http.get<IZoneAreaGetRes>({
    url: `/ufg/web/v1/region-area/get/${regionId}`,
    isCancelDuplicateUrlRequests: true,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
